<template>
  <div class="information">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="信用卡拒付" name="first">
        <Dishonor v-if="activeName=='first'"></Dishonor>
      </el-tab-pane>
      <el-tab-pane label="信用卡退款" name="second">
        <RefundFee v-if="activeName=='second'"></RefundFee>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import RefundFee from './RefundFee/RefundFee'
import Dishonor from './Dishonor/Dishonor'
export default {
  name: 'CreditCardFeeImport',
  components: {
    RefundFee,
    Dishonor
  },
  data() {
    return {
      activeName: 'first'
    }
  }
}
</script>
